import { number, bool, string, node, arrayOf, oneOfType, oneOf } from "prop-types";
import { BreakdownTableDepths } from "@repo/utils";
import { ELEMENT_TYPES } from "@utils";
import Grid from "@material-ui/core/Grid";
import useStyle from "./RowGroup.style";
import classnames from "classnames";
import { forwardRef, memo, useMemo } from "react";
import { useEstimateEditorSettings } from "@tools";

export const RowGroup = memo(forwardRef(({
  children,
  isActive,
  tableDepth = BreakdownTableDepths.SECTION,
  className,
  presetClass,
  isStatic,
  elementType,
  hashedPath,
  avoidPageBreaks,
}, ref) => {
  const { isPdfPrinterView, showRowGroupBorders } = useEstimateEditorSettings();
  const classes = useStyle();
  
  const dataId = useMemo(() => (
    hashedPath?.slice(-1)[0]
  ), [hashedPath]);
  
  const dataPath = useMemo(() => (
    hashedPath?.slice(0, -1).join("/")
  ), [hashedPath]);

  return (
    <Grid
      ref={ref}
      item
      container
      role="rowgroup"
      // direction={tableDepth > 0 ? "column" : "row"}
      direction="column"
      alignItems="flex-start"
      className={classnames(
        presetClass,
        "tableRowGroup",
        `d${tableDepth}`,
        classes.rowGroup,
        avoidPageBreaks && classes.avoidPageBreaks,
        isPdfPrinterView && showRowGroupBorders && classes.bordered,
        !presetClass && tableDepth === BreakdownTableDepths.MODULE && "preset-accent",
        isActive && tableDepth > BreakdownTableDepths.SECTION && "active",
        isStatic && "static",
        className
      )}
      aria-selected={isActive}
      data-id={dataId}
      data-p={dataPath}
      data-t={elementType}
    >
      {children}
    </Grid>
  );
}))

RowGroup.propTypes = {
  children: oneOfType([node, arrayOf(node)]).isRequired,
  isActive: bool,
  className: string,
  presetClass: string,
  id: oneOfType([string, number]),
  isStatic: bool,
  //common
  tableDepth: number,
  highlightCellText: bool,
  avoidPageBreaks: bool,
  
  elementType: oneOf(Object.values(ELEMENT_TYPES)),
  hashedPath: arrayOf(oneOfType([number, string])), //element ids parsed through "hashCode" func
};
